import { SubmitAction, SubmitActionTypes } from 'modules/Tasks/types';

// Action types that open an in-place overlay (modal / drawer) rather than navigating the member away.
const OVERLAY_SUBMIT_ACTION_TYPES: ReadonlySet<SubmitAction['type']> = new Set([
    SubmitActionTypes.UPLOAD,
    SubmitActionTypes.FORM,
    SubmitActionTypes.DOWNLOAD,
    SubmitActionTypes.CUSTOM,
]);

/**
 * Whether a task's submit_action opens an overlay in place (vs. navigating away). Deep-link auto-open
 * only fires for overlay actions: auto-navigating a member on page load is hostile, and an external
 * `window.open` without a user gesture is popup-blocked anyway. This is an allowlist, so a future
 * navigational action type is safe by default — it stays non-auto-opening until explicitly added here.
 */
export default function isOverlaySubmitAction(submit: SubmitAction): boolean {
    return OVERLAY_SUBMIT_ACTION_TYPES.has(submit.type);
}
